import * as PIXI from 'pixi.js'

const ensureParticlePool = (app) => {
  if (!app.userData.textParticlePool) {
    app.userData.textParticlePool = []
  }
  return app.userData.textParticlePool
}

const applyTextStyle = (text, fontSize, color) => {
  text.style.fontFamily = 'Arial'
  text.style.fontSize = fontSize
  text.style.fill = color
  text.style.fontWeight = 'bold'
}

export function createFloatingTextParticle(app, x, y, textValue, options = {}) {
  if (!app || !app.userData || !app.userData.particles) return

  const isMobile = typeof window !== 'undefined' && window.innerWidth <= 640

  const {
    fontSize = isMobile ? 18 : 12,
    color = 0xffffff,
    dy = -0.4,
    alphaStep = 0.02,
    maxParticles = 60,
  } = options

  const particles = app.userData.particles
  if (maxParticles && particles.length >= maxParticles) {
    return
  }

  const pool = ensureParticlePool(app)

  let particle = pool.pop()
  let container
  let text

  if (!particle) {
    container = new PIXI.Container()
    text = new PIXI.Text(textValue, {
      fontFamily: 'Arial',
      fontSize,
      fill: color,
      fontWeight: 'bold',
    })
    text.anchor.set(0.5, 0.5)
    container.addChild(text)

    particle = {
      graphics: container,
      textObject: text,
      alpha: 1,
      dy,
      alphaStep,
      update() {
        if (!this.graphics || !this.graphics.parent) return
        this.graphics.position.y += this.dy
        this.alpha -= this.alphaStep
        this.graphics.alpha = this.alpha
      },
      isDead() {
        return this.alpha <= 0
      },
    }
  } else {
    container = particle.graphics
    text = particle.textObject
    applyTextStyle(text, fontSize, color)
    text.text = textValue
  }

  container.position.set(x, y)
  container.alpha = 1
  if (!container.parent) {
    app.stage.addChild(container)
  }

  particle.alpha = 1
  particle.dy = dy
  particle.alphaStep = alphaStep
  particle.graphics.alpha = 1
  particle.textObject = text

  const release = () => {
    if (particle.graphics && particle.graphics.parent) {
      particle.graphics.parent.removeChild(particle.graphics)
    }
    particle.graphics.alpha = 1
    particle.alpha = 1
    if (!pool.includes(particle)) {
      pool.push(particle)
    }
  }

  particle.destroy = release
  particle.textObject = text

  particles.push(particle)
}
